<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Users</h1>
        </div>
        <users :readonly="true" :filterable="false" />
    </vue-scroll>
</template>

<script>
import Users from "./../user/ListAll";

export default {
    components: {
        Users
    },
    data() {
        return {};
    },
    methods: {}
};
</script>
